import React from 'react';
import { Form, InputNumber } from 'antd';
import './Changepass.scss';
import { FormInstance } from 'antd/lib/form';
import { observer } from 'mobx-react';
export type IchangePassProps = {
  form: FormInstance;
  onFormFinish: (values: any) => void;
};

const Changeparameter: React.FC<IchangePassProps> = observer(props => {
  return (
    <div className="ChangepassStyles">
      <Form form={props.form} onFinish={props.onFormFinish}>
        <Form.Item
          name="days"
          label="Days"
          rules={[
            {
              required: true,
              message: 'Enter how many days?'
            }
          ]}
        >
          <InputNumber />
        </Form.Item>
        <Form.Item
          name="quantity"
          label="Quantity"
          rules={[
            {
              required: true,
              message: 'Enter how many quantity?'
            }
          ]}
        >
          <InputNumber />
        </Form.Item>
        <Form.Item
          name="threshold"
          label="Threshold"
          rules={[
            {
              required: true,
              message: 'Enter how many threshold?'
            }
          ]}
        >
          <InputNumber max={100} />
        </Form.Item>
      </Form>
    </div>
  );
});

export default Changeparameter;
